import { useEffect, useState }                from 'react'
import { getFocus, useAtom, useGet }                 from 'state/jotai'
import { active_project, share_content, vis_no_available_unit }           from 'state/store.global'
import { vis_share }               from 'state/store.global'
import { Backdrop }                from 'styles/styles.backdrop'
import { STATICS }                 from 'api/api'
import { Icon }                    from 'assets/Icons_'
import { Button, Stack , ClickAwayListener , Tooltip }           from '@mui/material'
import { Container, Footer, Inner, Input } from './NoAvailableUnit.Portal.style'
import { useTranslation }          from 'react-i18next'
import { useSnackbar } from 'notistack';

import { _project } from 'state/store.projects'
import { _bootstrap } from 'state/store.bootstrap'
import { useBreak } from 'hooks/useBreak'

import { useActiveUnit } from 'components/Unit'
import { CustomButton } from 'components/Unit/NewReservationButton'
import { NoAvailableUnitForm } from './NoAvailableUnit.form'
import { ThankYouPage } from './NoAvailableUnit.ThankYouPage'


export const NoAvailableUnit = ({}) => {
  const unit    = useActiveUnit();
  const content = useAtom(share_content)[0]
  const [step, setStep] = useState(1)

  const setAvailableUnit                = useAtom(vis_no_available_unit)[1];
  const { i18n:{language} }             = useTranslation()
  const [email, setEmail]               = useState("")
  const [shareTooltip, setShareTooltip] = useState(false);
  const isMobile                        = useBreak("md_dn");
  
  const { pin, pid } = useGet(active_project)
  
  const buttonsLabel = getFocus(_project, 'buttonsLabel')?.[pin]?.[pid] ?? []

  const close   = { icon: 'close', color: '#000', wrap: { position: 'absolute', top: 20, right: 20 }, size: '16', click: () => setAvailableUnit(false), }
  const homeUrl = window.location.origin;
  const unitUrl = `${homeUrl}/${language}/unit/${content?.unitId}`;
  let clearTooltip;  

  return (
    <div > 
    <form >
      <Backdrop  onClick  = {() => { setShare(false) }} />
      <Container isMobile = {isMobile}>
        {
          step === 1 ?
          <>
              <img       src      = {`${STATICS}/svg/no-available-unit-image-1.svg`} alt = ''  style = {{ height : isMobile ? "150px" : "250px", objectFit: "contain", borderRadius:"6px", marginTop: "24px" }} />
              <Icon {...close} />
              <Inner>
                <div    className = 'h3'>{ form1Translation['heading'][language] }</div>
                <div    className = 'paragraph1-regular'>{ form1Translation['paragraph1'][language] }</div>
                <div    className = 'paragraph1-regular'>{ form1Translation['paragraph2'][language] }</div>
                <div    className = 'paragraph1-regular'>{ form1Translation['paragraph3'][language] }</div>
              </Inner>
              <Footer>
                <CustomButton
                    padding = {'12px 24px'}
                    variant = { "secondary" }
                    onClick = {() => setAvailableUnit(false)}
                    clr = {clr}
                  >
                    <span className = "eus-button-2">
                      { form1Translation[isMobile ? 'mobile_button1' : 'button1'][language] }
                    </span>
                  </CustomButton>
                  <CustomButton
                    padding = {'12px 24px'}
                    variant = { "primary" }
                    onClick = {() => setStep(2)}
                    clr = {clr}
                  >
                    <span className = "eus-button-2">
                    { form1Translation[isMobile ? 'mobile_button2' : 'button2'][language] }
                    </span>
                  </CustomButton>
              </Footer>
          </>
          :
          step === 2 ?
          <NoAvailableUnitForm {...close} setAvailableUnit={setAvailableUnit} setStep={setStep} />
          : 
          <ThankYouPage {...close} setAvailableUnit={setAvailableUnit} setStep={setStep} />
        }
      </Container>
    </form>
    </div>
  )

}



const form1Translation = {
  'heading': {
    'en': 'Oh no! No available units',
    'da': 'Nå ja! Ingen tilgængelige enheder'
  },
  'paragraph1': {
    'en': 'Unfortunately we do not have any available units.',
    'da': 'Vi har desværre ingen ledige enheder.'
  },
  'paragraph2': {
    'en': 'If you are interested to read more about the property and surroundings you can do so here: projektwebsite.dk. You can also explore the property in the unit selector.',
    'da': 'Hvis du er interesseret i at læse mere om ejendommen og omgivelserne kan du gøre det her: projektwebsite.dk. Du kan også udforske ejendommen i enhedsvælgeren.'
  },
  'paragraph3': {
    'en': 'Sign up to create a matching profile. When a unit that matches your needs become available you will get notified on email.',
    'da': 'Tilmeld dig for at oprette en matchende profil. Når en enhed, der matcher dine behov bliver tilgængelig, får du besked på e-mail.'
  },
  'button1': {
    'en': 'See unit selector anyway',
    'da': 'Se under alle omstændigheder enhedsvælger'
  },
  'button2': {
    'en': 'Sign up for matching',
    'da': 'Tilmeld dig matching'
  },
  'mobile_button1': {
    'en': 'See unit selector',
    'da': 'Se enhedsvælger'
  },
  'mobile_button2': {
    'en': 'Sign up',
    'da': 'Tilmeld dig'
  },
}